import { BaseConfig } from "../config.interface";

interface ISliderConfig {
    label?: string;
    min?: number;
    max?: number;
    step?: number;
    range?: boolean;
    showRange?: boolean;
}


export class SliderConfig extends BaseConfig<ISliderConfig> implements ISliderConfig {
    /**
     * Label of the element.
     */
    label?: string;
    /**
     * Min value of the slider.
     */
    min?: number;
    /**
     * Max value of the slider.
     */
    max?: number;
    /**
     * Step size of the slider.
     */
    step?: number;
    /**
     * Allows selection of a value range.
     */
    range?: boolean;
    /**
     * Show min and max values at the ends of the slider.
     */
    showRange?: boolean;

    /**
     * @theme Base
     */
    static baseTheme = {
        /**
         * Default configuration.
         * Range from 0 to 100. 
         */
        Default: new SliderConfig({
            min:       0,
            max:       100,
            step:      1,
            showRange: true,
        }),

        /**
         * Percentage selection.
         * Range from 0 to 1 in 0.1 increments.
         */
        Percentage: new SliderConfig({
            label:     "Prozent",
            min:       0,
            max:       1,
            step:      0.1,
            showRange: true,
        }),

        Hue: new SliderConfig({
            min:       0,
            max:       360,
            step:      1,
            showRange: false,
        }),

        Saturation: new SliderConfig({
            min:       .25,
            max:       1,
            step:      .05,
            showRange: false,
        }),
    };

}
